<div class="whatsapp-container">
    <a target="_blank" href="https://wa.me/{{phoneWhatsapp}}">
        <img class="img-whatsapp" src="https://firebasestorage.googleapis.com/v0/b/ianos-app-new-rolling-uat.appspot.com/o/assets%2Fimages%2Fwhatsapp.png?alt=media&token=7526d129-3e7b-42a5-9adf-0fcbb27ec20c" alt="WhatsApp" />
    </a>
</div>
